import { createContext, RefObject } from 'react';

export type StepContextType = {
  scrollableRef: RefObject<HTMLElement | null>;
  targetRef: RefObject<HTMLDivElement | null>;
  scrollToActiveStep: () => void;
};

const StepContext = createContext<StepContextType | null>(null);

export default StepContext;
